import React, { useState } from "react";
import ModalComponent from "@/components/modal";
import { Col, Flex, Row, Select } from "antd";
import "@/styles/form/selectSlot.scss";
import ButtonComponent from "@/components/button/Button";
import { updateUserAvailability } from "@/services/users/updateUserAvailability";
import { useDispatch } from "react-redux";
import { setModalOpen } from "@/reducers/commonSlice";

const hours = [
  {
    label: "01",
    value: "01",
  },
  {
    label: "02",
    value: "02",
  },
  {
    label: "03",
    value: "03",
  },
  {
    label: "04",
    value: "04",
  },
  {
    label: "05",
    value: "05",
  },
  {
    label: "06",
    value: "06",
  },
  {
    label: "07",
    value: "07",
  },
  {
    label: "08",
    value: "08",
  },
  {
    label: "09",
    value: "09",
  },
  {
    label: "10",
    value: "10",
  },
  {
    label: "11",
    value: "11",
  },
  {
    label: "12",
    value: "12",
  },
  {
    label: "13",
    value: "13",
  },
  {
    label: "14",
    value: "14",
  },
  {
    label: "15",
    value: "15",
  },
  {
    label: "16",
    value: "16",
  },
  {
    label: "17",
    value: "17",
  },
  {
    label: "18",
    value: "18",
  },
  {
    label: "19",
    value: "19",
  },
  {
    label: "20",
    value: "20",
  },
  {
    label: "21",
    value: "21",
  },
  {
    label: "22",
    value: "22",
  },
  {
    label: "23",
    value: "23",
  },
  {
    label: "00",
    value: "00",
  },
];

const minutes = [
  {
    label: "00",
    value: "00",
  },
  {
    label: "30",
    value: "30",
  },
];

const SelectSlot = ({
  isOpen,
  start = "09:00",
  end = "10:00",
  isNew,
  day,
  currentSlot = [],
  onSave,
}) => {
  const [error, setError] = useState(false);
  const [startTime, setStartTime] = useState(start.split(":")[0]);
  const [endTime, setEndTime] = useState(end.split(":")[0]);
  const [startMinutes, setStartMinutes] = useState(start.split(":")[1]);
  const [endMinutes, setEndMinutes] = useState(end.split(":")[1]);
  const [fromHours, setFromHours] = useState(hours);
  const [fromMinutes, setFromMinutes] = useState(minutes);
  const [toHours, setToHours] = useState(hours);
  const [toMinutes, setToMinutes] = useState(minutes);
  const dispatch = useDispatch();

  console.log(start, end);
  const handleHours = (type, value) => {
    if (type === "from") {
      setStartTime(value);
      const hoursClone = hours;
      const sIndex = hoursClone.findIndex((x) => x.value === value);
      setToHours(hoursClone.slice(sIndex));
      setEndTime("");
      setEndMinutes("");
    } else {
      setEndTime(value);
      if (value === startTime) {
        const minutesClone = minutes;
        const tIndex = minutesClone.findIndex((x) => x.value === startTime);
        setToMinutes(minutesClone.slice(tIndex));
        setEndMinutes("");
      }
    }
  };
  const handleMinutes = (type, value) => {
    if (type === "from") {
      setStartMinutes(value);
      setEndMinutes("");
      if (value == "30") {
        const hoursClone = hours;
        const sIndex = hoursClone.findIndex((x) => x.value === startTime);
        setToHours(hoursClone.slice(sIndex + 1));
        setEndTime("");
      } else {
        setStartMinutes(value);
        const minutesClone = minutes;
        const tIndex = minutesClone.findIndex((x) => x.value === value);
        setToMinutes(minutesClone.slice(tIndex + 1));
        setEndMinutes("");
      }
    } else {
      setEndMinutes(value);
    }
  };

  const handleSaveSlot = () => {
    if (startTime.length && endTime.length && startMinutes.length && endMinutes.length) {
      updateUserAvailability({
        days: [day],
        timeslots: [
          ...currentSlot,
          {
            start: `${startTime}:${startMinutes}`,
            end: `${endTime}:${endMinutes}`,
          },
        ],
      }).then((res) => {
        console.log(res);
        dispatch(setModalOpen(false));
        onSave();
      });
    } else {
      setError(true);
    }
  };
  return (
    <ModalComponent isOpen={isOpen} width={347} className="select-slot-wrapper">
      <Flex vertical gap="1rem">
        <Flex justify="center" className="body-b2">
          {isNew ? "Select " : "Edit "}Time Slot
        </Flex>
        <Flex vertical justify="flex-start" align="start">
          <div className="body-b3">From:</div>
          <Row gutter={[16, 16]} gap="10px" className="w-100">
            <Col xs={12}>
              <Select
                virtual={false}
                showSearch
                options={fromHours}
                onChange={(val) => handleHours("from", val)}
                value={startTime}
              />
            </Col>
            <Col xs={12}>
              <Select
                virtual={false}
                showSearch
                options={fromMinutes}
                onChange={(val) => handleMinutes("from", val)}
                value={startMinutes}
              />
            </Col>
            {/* <Col xs={6}>
              <Flex vertical className="h-100 meradian-wrapper">
                <div className="meradian-chip">AM</div>
                <div className="meradian-chip">PM</div>
              </Flex>
            </Col> */}
          </Row>
        </Flex>
        <Flex vertical justify="flex-start" align="start">
          <div className="body-b3">To:</div>
          <Row gutter={[16, 16]} gap="0.8rem" className="w-100">
            <Col xs={12}>
              <Select
                virtual={false}
                showSearch
                options={toHours}
                onChange={(val) => handleHours("to", val)}
                value={endTime}
              />
            </Col>
            <Col xs={12}>
              <Select
                virtual={false}
                showSearch
                options={toMinutes}
                onChange={(val) => handleMinutes("to", val)}
                value={endMinutes}
              />
            </Col>
            {/* <Col xs={6}>
                        <Flex vertical className="h-100 meradian-wrapper">
                            <div className='meradian-chip'>AM</div>
                            <div className='meradian-chip'>PM</div>
                        </Flex>
                    </Col> */}
          </Row>
        </Flex>
        {error ? <div className="error-msg">Please Select all slot</div> : <></>}
        <ButtonComponent
          varient="primary"
          label={`${isNew ? "Add " : "Update "}Time Slot`}
          onClick={handleSaveSlot}
        />
      </Flex>
    </ModalComponent>
  );
};

export default SelectSlot;
